<template>
  <c-view>
    <c-page>
      <c-navbar></c-navbar>
      <c-content>
        <c-cell-container class="mg-0">
          <c-cell v-for="(item,index) in cellList"
                  :icon="item.icon"
                  :title="item.title" :desc="item.desc"
                  :key="index"
                  @click.native="itemClick(item)"
                  class="cell-item">
          </c-cell>
        </c-cell-container>
      </c-content>
    </c-page>
    <transition name="slide-right" mode="out-in">
      <router-view></router-view>
    </transition>
  </c-view>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  import AboutMe from '../../model/about-user'
  export default{
    data () {
      return {
        cellList: [{
          id: 1,
          title: '我的订单',
          desc: '',
          path: 'orderDetail',
          icon: require('../../assets/images/icon/order-icon@2x.png')
        }
        // , {
        //   id: 2,
        //   title: '我的礼金券',
        //   desc: '',
        //   path: 'ticketDetail',
        //   icon: require('../../assets/images/icon/ticket-icon@2x.png')
        // }, {
        //   id: 3,
        //   title: '我的积分',
        //   desc: '',
        //   path: 'integralDetail',
        //   icon: require('../../assets/images/icon/integral-icon@2x.png')
        // }
        ],
        aboutMe: new AboutMe()
      }
    },
    components: {},
    created () {
      this.aboutMe.index().then(res => {
        this.cellList[0]['desc'] = `${res['orderCount']}笔`
        this.cellList[1]['desc'] = `${res['coupon']}张可用`
        this.cellList[2]['desc'] = `${res['integral']}分`
      }).catch(e => {})
    },
    mounted () {},
    beforeDestroy () {},
    methods: {
      itemClick (itemObj) {
        this.$router.push({path: `${this.$route.path}/${itemObj.path}`})
      }
    },
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?f61b1682